<template>
  <div style="width: 100%" class="fill-height">
    <v-btn
      style="z-index: 4"
      rounded
      fixed
      bottom
      right
      color="primary"
      @click="openaddItemForm"
      v-if="$vuetify.breakpoint.smAndDown"
    >
      <v-icon>mdi-plus</v-icon>
      <span>{{ $t(`$vuetify.company.addLagerItemBtn`) }}</span>
    </v-btn>
    <v-container>
      <v-row v-if="listView" class="justify-center">
        <v-col cols="12" sm="11" lg="11" :class="['px-0']">
          <!-- Sticky Header -->
          <div class="norm-sticky-header">
            <div class="norm-thead">
              <div style="width:6%;"></div>
              <div class="norm-thead-cell" style="width:43%;">Naziv artikla</div>
              <div class="norm-thead-cell" style="width:18%;">Šifra</div>
              <div class="norm-thead-cell" style="width:23%;">Vrsta</div>
              <div class="norm-thead-cell" style="width:5%; text-align:center;">Stanje</div>
              <div style="width:5%;"></div>
            </div>
          </div>

          <!-- Rows -->
          <div class="norm-rows-body">
            <div
              v-for="(item, i) in items"
              :key="i"
              class="norm-row"
              :class="getRowClass(item.status)"
            >
              <div class="norm-row-inner">
                <div class="norm-cell-img" style="width:6%; padding-right:0;">
                  <v-img
                    v-if="item.picture"
                    :src="item.picture"
                    contain
                    height="44"
                    style="border-radius:6px; max-width:44px;"
                  ></v-img>
                  <div v-else style="width:44px; height:44px; border-radius:6px; background:#F1F5F9; margin-right:16px;"></div>
                </div>
                <div class="norm-cell" style="width:43%;">
                  <span class="norm-name one-liner-text">{{ $options.filters.capitalize(item.name) }}</span>
                </div>
                <div class="norm-cell" style="width:18%;">{{ item.code }}</div>
                <div class="norm-cell" style="width:23%;">{{ $t(`$vuetify.lager.itemTypes.${item.type.toLowerCase()}`) }}</div>
                <div class="norm-cell" style="width:5%; justify-content:center;">
                  <v-chip x-small :class="getStatusChipClass(item.status)">
                    {{ showStatus(item.status) }}
                  </v-chip>
                </div>
                <div class="norm-cell-actions" style="width:5%;">
                  <v-menu offset-y left>
                    <template #activator="{ on, attrs }">
                      <v-btn icon small v-on="on" v-bind="attrs">
                        <v-icon size="18" color="#94A3B8">mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense class="norm-kebab-list">
                      <v-list-item @click="addItemPrice(item)" class="norm-menu-item">
                        <v-icon small color="#00838F" class="mr-2">mdi-credit-card-plus</v-icon>
                        <v-list-item-title class="norm-menu-title norm-menu-pricelist">Dodaj na cjenik</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row
        v-else
        class="d-flex justify-center align-center flex-wrap fill-height ma-0 pa-0"
      >
        <v-card
          class="norm-grid-card ma-4"
          v-for="(item, i) in items"
          :key="i"
          hover
          height="300"
          width="250"
        >
          <div
            class="norm-grid-header"
            :class="[
              item.status === 'OK'
                ? 'status-ok-header'
                : item.status === 'PROCESSING'
                  ? 'status-processing-header'
                  : 'status-failed-header'
            ]"
          >
            <v-img
              height="190"
              width="250"
              v-if="item.picture"
              :src="item.picture"
              class="norm-grid-image"
            >
            </v-img>
            <div v-else class="no-image-placeholder">
              <v-icon size="64" color="rgba(57, 137, 201, 0.3)">mdi-image-off</v-icon>
            </div>
          </div>
          <div class="norm-grid-content">
            <h3 class="norm-grid-title one-liner-text">
              {{ $options.filters.capitalize(item.name) }}
            </h3>
            <p
              class="norm-grid-status one-liner-text"
              :class="[
                item.status === 'OK'
                  ? 'status-text-ok'
                  : item.status === 'PROCESSING'
                    ? 'status-text-processing'
                    : 'status-text-failed'
              ]"
            >
              Status: {{ showStatus(item.status) }}
            </p>
          </div>
        </v-card>
      </v-row>
      <infinite-loading
        ref="InfiniteLoading"
        @infinite="infiniteHandler"
        spinner="waveDots"
      >
        <div slot="no-more" class="text--secondary font-italic"></div>
        <div slot="no-results" class="text--secondary font-italic"></div>
      </infinite-loading>
    </v-container>
    <add-pricelist-item v-if="!warehouseModule" ref="addPricelistItem" />
  </div>
</template>
<script>
import { df } from '@/plugins/firebase'
import state from '@/state'
import InfiniteLoading from 'vue-infinite-loading'
import addPricelistItem from '@/modules/point-of-sale/components/AddPricelistItem'
import flow from '@/mixins/flow'
import applicationSettings from '@/mixins/applicationSettings' // don't move.. detaches firebase listeners
import barcodeChecker from '@/mixins/barcodeChecker'
import { clone } from '@/plugins/utils'
export default {
  inject: ['showLoader', 'confirm', 'confirmClose', 'hideLoader'],
  mixins: [flow, applicationSettings, barcodeChecker],
  components: { InfiniteLoading, addPricelistItem },
  data: () => ({
    loading: false,
    lastiItem: false,
    options: {},
    pagination: {
      itemsPerPage: 10, // TODO: change to 30 after testing.
      page: 1
    },
    headers: [],
    items: [],
    avatarSize: 120,
    lastVisible: '',
    listeners: [],
    newItem: false,
    warehouseModule: false
  }),
  mounted () {
    if (state.getCurrentCompany().warehouse === 'module') {
      this.warehouseModule = true
    }
  },
  computed: {
    listView () {
      return state.isListView()
    }
  },
  watch: {
    listView (nv, ov) {
      if (nv !== ov) {
        if (this.$refs.InfiniteLoading) {
          this.$refs.InfiniteLoading.stateChanger.reset()
        }
      }
    },
    companyId (nv, ov) {
      if (nv !== ov) {
        this.detachListeners()
        this.items = []
        if (this.$refs.InfiniteLoading) {
          this.$refs.InfiniteLoading.stateChanger.reset()
        }
      }
    },
    search () {
      this.lastVisible = ''
      this.items = []
      if (this.$refs.InfiniteLoading) {
        this.$refs.InfiniteLoading.stateChanger.reset()
      }
    }
  },
  methods: {
    getRowClass (status) {
      if (status === 'OK') return 'status-ok'
      if (status === 'PROCESSING') return 'status-warn'
      return 'status-failed'
    },
    getStatusChipClass (status) {
      if (status === 'OK') return 'status-chip-ok'
      if (status === 'PROCESSING') return 'status-chip-warn'
      return 'status-chip-failed'
    },
    showStatus (status) {
      switch (status) {
        case 'OK':
          return 'Aktivan'
        case 'PROCESSING':
          return 'Procesira se'
        case 'FAILED':
          return 'Greška'
        default:
          return status
      }
    },
    hoverOver (ref, item) {
      const container = this.$refs[ref]
      if (!container || !container[0]) return
      if (container[0].associateHeight < container[0].scrollHeight) {
        item[ref] = true
      }
    },
    openaddItemForm () {
      if (this.warehouseModule) {
        this.$refs.addWhItem.open()
      } else {
        this.$refs.addItem.open()
      }
    },
    openEditForm (item) {
      if (this.warehouseModule) {
        this.$refs.editWhItem.open(item)
      } else {
        this.$refs.editItem.open(item)
      }
    },
    refreshLager (item) {
      if (item.action === 'ADD') {
        this.newItem = true
        this.items.unshift(
          { ...item, ...{ status: 'PROCESSING' } }
        )
        this.$vuetify.goTo(0)
      } else if (item.action === 'EDIT') {
        this.items = this.items.map(_item => {
          if (_item.id === item.id) {
            _item.name = item.name
            _item.status = 'PROCESSING'
          }
          return _item
        })
      }
    },
    addItemPrice (item) {
      this.$refs.addPricelistItem.open(item)
    },
    modifyItems (change) {
      if (change.type === 'added') {
        if (this.items.some(item =>
          (item.id === change.doc.data().id) ||
          (item.name.toLowerCase() === change.doc.data().name && item.status === 'PROCESSING')
        )) {
          this.items = this.items.map(item => {
            let ret = item
            if (((item.id === change.doc.data().id) || (item.name === change.doc.data().name.toLowerCase() && item.status === 'PROCESSING')) && this.newItem) {
              ret = change.doc.data()
              if (ret.status === 'OK' && !this.warehouseModule) {
                this.confirm({
                  title: 'Dodaj cijenu',
                  message: `Dodaj cijenu za novododani artikl ${item.name} ?`,
                  options: {
                    toolbar: true,
                    confirmText: 'Dodaj',
                    cancelText: 'Odustani'
                  }
                }).then(resp => {
                  if (resp) {
                    this.addItemPrice(change.doc.data())
                  }
                  this.confirmClose()
                }).finally(() => {
                  this.newItem = false
                })
              }
            }
            return { ...ret, ...{ [`hover-${change.doc.data().id}`]: false } }
          })
        } else {
          this.items.push({ ...change.doc.data(), ...{ [`hover-${change.doc.data().id}`]: false } })
        }
      }
      if (change.type === 'modified') {
        this.items = this.items.map(item => {
          let ret = item
          if (item.id === change.doc.data().id) {
            ret = change.doc.data()
          }
          return { ...ret, ...{ [`hover-${change.doc.data().id}`]: false } }
        })
      }

      this.items = clone(this.items.sort((a, b) => a.name.localeCompare(b.name)))
    },
    infiniteHandler ($state) {
      let search = 'name'
      if (this.isBarcodeSearch(this.search)) {
        search = 'barcode'
      }
      const where = this.search ? this.search.toLowerCase() : ''

      let query = df.collection(`companies/${state.getCurrentCompany().id}/items`)
        .orderBy(search, 'asc')
        .limit(10)
        .startAfter(this.lastVisible)
      if (where !== undefined && where !== '') {
        query = query.where(search, '>=', where).where(search, '<=', where + '\uf8ff')
      }
      query = query.where('has_norm', '==', true)
      const listener = query
        .onSnapshot((doc) => {
          doc.docChanges().forEach(change => {
            this.modifyItems(change)
          })
          if (doc && !doc.empty) {
            if (doc.docs[doc.docs.length - 1]) {
              this.lastVisible = doc.docs[doc.docs.length - 1]
            }
            $state.loaded()
          } else {
            $state.complete()
          }
        }
        // (error) => {
        //   console.log('error', error)
        // }
        )

      this.listeners.push(listener)
    }
  }
}
</script>
<style scoped>
/* ── Sticky Header ─────────────────────────────────────────── */
.norm-sticky-header {
  position: -webkit-sticky;
  position: sticky;
  top: 64px;
  z-index: 10;
  background: #ffffff;
  padding: 0;
  border-left: 3px solid #00BCD4;
  border-bottom: 1px solid #EEF2F5;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}

.norm-thead {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.norm-thead-cell {
  font-size: 11px;
  font-weight: 600;
  color: #94A3B8;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  padding: 0 8px;
}

/* ── Rows ──────────────────────────────────────────────────── */
.norm-rows-body {
  background: #F5F7FA;
  padding: 6px 0 2px;
}

.norm-row {
  display: flex;
  align-items: stretch;
  border: 1px solid #EEF2F5;
  border-left: 3px solid #E0E0E0;
  border-radius: 6px;
  background: #ffffff;
  transition: border-left-color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
  min-height: 56px;
  margin-bottom: 4px;
  overflow: hidden;
}

.norm-row:hover {
  border-color: #00BCD4 !important;
  background: #F8FAFB !important;
}

.norm-row.status-ok     { border-left-color: #4ADE80 !important; }
.norm-row.status-warn   { border-left-color: #FBBF24 !important; }
.norm-row.status-failed { border-left-color: #F87171 !important; }

.norm-row-inner {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 56px;
}

.norm-cell-img {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  flex-shrink: 0;
}

.norm-cell {
  display: flex;
  align-items: center;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.87);
  padding: 0 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.norm-cell-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 8px;
  flex-shrink: 0;
}

.norm-name {
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Status Chips ──────────────────────────────────────────── */
.status-chip-ok     { background: #DCFCE7 !important; color: #166534 !important; font-weight: 600 !important; }
.status-chip-warn   { background: #FEF9C3 !important; color: #854D0E !important; font-weight: 600 !important; }
.status-chip-failed { background: #FEE2E2 !important; color: #991B1B !important; font-weight: 600 !important; }

/* ── Kebab ─────────────────────────────────────────────────── */
.norm-kebab-list  { padding: 4px 0 !important; min-width: 160px !important; }
.norm-menu-item   { min-height: 36px !important; padding: 0 12px !important; }
.norm-menu-item >>> .v-list-item__content { padding: 0 !important; display: flex !important; align-items: center !important; }
.norm-menu-title  { font-size: 13px !important; font-weight: 500 !important; line-height: 1 !important; }
.norm-menu-pricelist { color: #00838F !important; }

/* Grid View - Norm Cards */
.norm-grid-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.1) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  overflow: hidden;
}

.norm-grid-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 12px 48px rgba(0, 179, 190, 0.2) !important;
  border-color: rgba(0, 179, 190, 0.4) !important;
}

.norm-grid-header {
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Status Headers - Grid View */
.status-ok-header {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 0.5) 0%,
    rgba(56, 142, 60, 0.45) 50%,
    rgba(76, 175, 80, 0.5) 100%) !important;
}

.norm-grid-card:hover .status-ok-header {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 0.65) 0%,
    rgba(56, 142, 60, 0.6) 50%,
    rgba(76, 175, 80, 0.65) 100%) !important;
}

.status-processing-header {
  background: linear-gradient(135deg,
    rgba(255, 152, 0, 0.5) 0%,
    rgba(255, 193, 7, 0.45) 50%,
    rgba(255, 152, 0, 0.5) 100%) !important;
}

.norm-grid-card:hover .status-processing-header {
  background: linear-gradient(135deg,
    rgba(255, 152, 0, 0.65) 0%,
    rgba(255, 193, 7, 0.6) 50%,
    rgba(255, 152, 0, 0.65) 100%) !important;
}

.status-failed-header {
  background: linear-gradient(135deg,
    rgba(244, 67, 54, 0.5) 0%,
    rgba(211, 47, 47, 0.45) 50%,
    rgba(244, 67, 54, 0.5) 100%) !important;
}

.norm-grid-card:hover .status-failed-header {
  background: linear-gradient(135deg,
    rgba(244, 67, 54, 0.65) 0%,
    rgba(211, 47, 47, 0.6) 50%,
    rgba(244, 67, 54, 0.65) 100%) !important;
}

.norm-grid-image {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.norm-grid-card:hover .norm-grid-image {
  transform: scale(1.05);
}

/* No Image Placeholder */
.no-image-placeholder {
  height: 190px;
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(245, 245, 245, 0.5);
}

.norm-grid-content {
  padding: 16px;
  min-height: 90px;
}

.norm-grid-title {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  margin-bottom: 4px !important;
  letter-spacing: 0.3px !important;
}

.norm-grid-status {
  font-size: 15px !important;
  font-weight: 500 !important;
  margin-bottom: 4px !important;
}

/* Font Weight */
.font-weight-medium {
  font-weight: 500 !important;
}

/* One Liner Text */
.one-liner-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
